import { createEntityAdapter } from '@reduxjs/toolkit';
import * as i from './preSeasonInterfaces';

export const preSeasonEntityAdapters = {
  approvalTypes: createEntityAdapter<i.IPreSeasonApprovalType>({ selectId: x => x.preseasonApprovalTypeId }),
  catalogSections: createEntityAdapter<i.IPreseasonCatalogSection>({ selectId: x => x.preseasonCatalogSectionId }),
  programLevels: createEntityAdapter<i.IProgramLevel>({ selectId: x => x.programLevelId }),
  psCarts: createEntityAdapter<i.IPreSeasonCartNormalized>({ selectId: x => x.brand })
} as const;
